/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconSearch.vue?vue&type=template&id=9ac04cd2"
import script from "./IconSearch.vue?vue&type=script&lang=js"
export * from "./IconSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ac04cd2')) {
      api.createRecord('9ac04cd2', component.options)
    } else {
      api.reload('9ac04cd2', component.options)
    }
    module.hot.accept("./IconSearch.vue?vue&type=template&id=9ac04cd2", function () {
      api.rerender('9ac04cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconSearch.vue"
export default component.exports